// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'bgImage';
angular.module(MODULE_NAME, [])

    .directive('bgImage', () => {
      return {
        scope: true,
        template: '',
        link: ($scope, element, attrs) => {

          function render() {
            let imgUrl = '';
            try {
              imgUrl = require(`../../public/images/${ attrs.bgImage }`);
            } catch (e) {
            // Unable to locate image
            // console.warn('Unable to locate image: ', attrs.bgImage);
            }
            if (imgUrl) {
              element[0].style.backgroundImage = `url(${ imgUrl })`;
            }
          }

          attrs.$observe('bgImage', (bgImage) => {
            if (bgImage) {
              render();
            }
          });
        },
      };
    });

export default MODULE_NAME;
